import { Box, Divider, Typography } from '@mui/material'
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined'
import { useTranslations } from 'next-intl'

import type { AreaToStay } from '@/src/types/destinationResult'

interface AreasToStayProps {
    areas: AreaToStay[]
}

const AreasToStay: React.FC<AreasToStayProps> = ({ areas }) => {
    const t = useTranslations('destinationPage')
    return (
        <Box component="section" sx={{ mb: 4 }}>
            <Typography
                component="h2"
                variant="h6"
                sx={{ fontWeight: 600, fontSize: { xs: '1rem', md: '1.1rem' }, mb: 2 }}
            >
                {t('areasToStay')}
            </Typography>
            <Box component="ul" sx={{ border: 1, borderColor: 'divider', borderRadius: 2, overflow: 'hidden', listStyle: 'none', p: 0, m: 0 }}>
                {areas.map((area, i) => (
                    <Box component="li" key={`${area.name}-${i}`}>
                        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: { xs: 1, sm: 1.5 }, p: { xs: 1.5, sm: 2 } }}>
                            <LocationOnOutlinedIcon sx={{ fontSize: { xs: 18, sm: 20 }, color: 'primary.main', mt: 0.25, flexShrink: 0 }} />
                            <Box>
                                <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 0.25 }}>
                                    {area.name}
                                </Typography>
                                <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.7 }}>
                                    {area.description}
                                </Typography>
                            </Box>
                        </Box>
                        {i < areas.length - 1 && <Divider />}
                    </Box>
                ))}
            </Box>
        </Box>
    )
}

export default AreasToStay
export type { AreasToStayProps }
